import Joi from 'joi';

export const EnjoinSchema = Joi.object({
  projectId: Joi.number().required(),
  title: Joi.string().required(),
  description: Joi.string().required(),
});

export const EnjoinAnswerSchema = Joi.object({
  projectEnjoinId: Joi.number().required(),
  userId: Joi.string().required(),
  userName: Joi.string().required(),
  description: Joi.string().required(),
});
